import React, { useEffect, useState } from "react";
import { AddToCalendarButton } from "../../../../core/AddToCalendarButton";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import styles from "./index.module.scss";
import { IAdress } from "../../../../../models/session";
import CurriculumCI from "../../../Curricula/CurriculumCI/CurriculumCI";
import CurriculumFolder from "../../../Curricula/CurriculumFolder/CurriculumFolder";
import moment from "moment-timezone";
import { formatDateForCalendar } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import { isMobileApp } from "../../../../../helpers/helpers";

moment.tz.setDefault("Asia/Jerusalem");

interface SessionContentProps {
    sessionId: string;
    sessionDescription: string;
    zoomUrl: string;
    sessionTitle: string;
    startDate: string;
    address: IAdress;
    room: string;
    startTime: string;
    endTime: string;
    related?: Array<any>;
    folders?: any[];
    entityLanguage: string
}

const SessionContent = ({ sessionDescription, entityLanguage, zoomUrl, sessionTitle, startDate, address, room, folders, sessionId, startTime, endTime, related }: SessionContentProps) => {
    const [t] = useTranslation(entityLanguage);
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const isMobile = isMobileApp();
    const formattedTime = {
        start: formatDateForCalendar(startTime),
        end: formatDateForCalendar(endTime),
    };

    return (
        <div className={styles.content}>
            <div className={styles.container}>
                <div className={styles.calendar}>
                    <div className="mb-auto">
                        {sessionDescription && (
                            <>
                                <div className={styles.title}>{t("Class Description")}</div>
                                <div className={styles.description}>{sessionDescription}</div>
                            </>
                        )}
                    </div>
                </div>
                <div className={`${styles.relatedContent} ${entityLanguage !== "English" ? styles.isNotEnglish : ""}}`}>
                    {related && related.length > 0 && (
                        <div className={styles.relatedContainer}>
                            <div className={styles.title}>{t("Related Content")}</div>
                            <div className={styles.contentContainer}>
                                {related
                                    && related.map((t: any, index) => (
                                        <CurriculumCI
                                            item={{ _id: t.value, title: t.label, description: "", type: t.url ? "external_link" : "file", media: [{ link: t.url }] }}
                                            mode={"outsideFolder"}
                                            key={index + "CurriculumCI"}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    )}

                    {folders?.length > 0 && (
                        <div className={`mt-2 d-flex flex-column ${styles.contentContainer}`}>
                            {folders.length > 1
                                ? folders.map((folder: any, index: number) => (
                                    <div className="flex-fill" key={index}>
                                        <CurriculumFolder item={folder} language={entityLanguage} />
                                    </div>
                                ))
                                : folders.map((folder: any) => (
                                    <div key={folder._id}>
                                        {folder.contentItems.map((item: any, index: number) => {
                                            return <CurriculumCI key={index} item={item} mode={"outsideFolder"} language={entityLanguage} />;
                                        })}
                                    </div>
                                ))}
                        </div>
                    )}
                </div>
            </div>
            <div className={styles.buttonContainer}>
                <div style={{ direction: "ltr" }}>
                    <AddToCalendarButton
                        name={sessionTitle}
                        startDate={formattedStartDate.toString()}
                        endDate={formattedStartDate.toString()}
                        buttonStyle="round"
                        options={["Apple", "Google", "Yahoo", "iCal"]}
                        location={address.street + " " + address.city + " " + address.state + " " + address.zip + " | " + room}
                        description={sessionDescription}
                    />
                </div>
                {zoomUrl && (
                    <div className={styles.zoomButtonWrapper}>
                        <a className={styles.zoomButton} rel="noreferrer" href={zoomUrl} target={isMobile ? "_self" : "_blank"}>
                            <span className={styles.zoomButtonIcon}>
                                <VideoLibraryIcon />
                            </span>
                            <span className={styles.zoomButtonText}>Zoom Join</span>
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SessionContent;